import { render, staticRenderFns } from "./PickUpRecord.vue?vue&type=template&id=38cf359a&scoped=true&"
import script from "./PickUpRecord.vue?vue&type=script&lang=js&"
export * from "./PickUpRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf359a",
  null
  
)

export default component.exports